import React, {memo, useEffect, useState} from 'react';
import {EnvelopeImageProps} from '~/common/FabricInvitation/EventCreateDesign/components/EnvelopeDisplay/types/EnvelopeTypes';

export const EnvelopeImage: React.FC<EnvelopeImageProps> = memo(({imageUrl, id, onLoad}) => {
  const [loaded, setLoaded] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    setLoaded(false);
  }, [imageUrl]);

  const handleLoad = () => {
    setLoaded(true);
    if (onLoad) onLoad();
  };

  return (
    <img
      src={imageUrl}
      className="envelope_image"
      id={id}
      alt="Envelope"
      onLoad={handleLoad}
      style={{opacity: loaded ? 1 : 0, transition: 'opacity 0.3s'}}
    />
  );
});
